module.exports = __webpack_public_path__ + "img/4ac74a5.png";